<template>
    <input type="text" class="form-control inputElement" :id="'value-'+id" :value="value" autocomplete="off">  
</template>

<script>
import "bootstrap-datepicker"
import "bootstrap-datepicker/js/locales/bootstrap-datepicker.de"
export default {
  name: "DateInput",
  data() {
    return {
      output: {}
    };
  },
  mounted() {
	  if(this.today) {
		  var date = new Date();
		  $('#value-'+this.id).val(this.$globals.formatDate(date));
	  }

       $('#value-'+this.id).datepicker({
       // format: 'dd.mm.yyyy',
        format: 'yyyy.mm.dd',
        language: 'de'
    });
       
       $('#value-'+this.id).datepicker()
       .on('changeDate', (e) => { 	   
        	this.$emit('date-change', this.$globals.formatDate(e.date))
       });
       
       
  },
  props: ["value", "id", "today"]
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/input/DateInput.vue